import { channels, mediums } from '../constants/acquisitionConstants';

import comesFromMailchimp from './comesFromMailchimp';

export default function getChannelAndMediumFromMailchimp(
  utmMedium: string | null,
  utmTerm: string | null
): { channel: string; medium: string } | null {
  if (!comesFromMailchimp(utmMedium, utmTerm)) return null;

  return { channel: channels.mailchimp, medium: mediums.organic };
}
